<template>
  <v-stepper v-model="step" vertical>
    <v-stepper-step :complete="step > 1" step="1" :editable="step == 2">
      Paste items
    </v-stepper-step>

    <v-stepper-content step="1">
      <table-to-basket-step1
        @continue="validateTableData"
      ></table-to-basket-step1>
    </v-stepper-content>

    <v-stepper-step :complete="step > 2" step="2">Check items</v-stepper-step>

    <v-stepper-content step="2">
      <table-to-basket-step2
        @continue="addItemsToBasket"
        @back="step = 1"
      ></table-to-basket-step2>
    </v-stepper-content>

    <v-stepper-step step="3">Summary</v-stepper-step>

    <v-stepper-content step="3">
      <v-alert :value="true" type="info">
        {{ itemCountString }} added to the basket.
      </v-alert>

      <v-btn class="ma-0" color="blue" outline to="/basket">
        <v-icon color="blue" class="pr-2">shopping_basket</v-icon>
        Go to basket
      </v-btn>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
import pluralize from "pluralize";
import TableToBasketStep1 from "@/components/TableToBasketStep1.vue";
import TableToBasketStep2 from "@/components/TableToBasketStep2.vue";

export default {
  components: {
    TableToBasketStep1,
    TableToBasketStep2
  },
  data() {
    return {
      step: 1
    };
  },
  computed: {
    items() {
      return this.$store.getters["getTableItems"];
    },
    itemCountString() {
      return pluralize("item", this.items.length, true);
    }
  },
  methods: {
    validateTableData() {
      this.step = 2;
      this.$store.dispatch("tableDataToItems");
      this.items.forEach((item, index) => {
        this.$store.dispatch("validateItem", { item, index });
      });
    },
    addItemsToBasket() {
      this.step = 3;
      if (!this.$store.state.basket.basketId) {
        this.$store.dispatch("basket/newBasket").then(() => {
          this.items.forEach(item => {
            this.$store.dispatch("basket/addToBasket", item);
          });
        });
      } else {
        this.$store.dispatch("basket/deleteBasket").then(() => {
          this.addItemsToBasket();
        });
      }
    }
  }
};
</script>
